var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.5a.25.25 0 00-.25.25v4a.75.75 0 01-.75.75h-4a.25.25 0 00-.25.25v4.5c0 .138.112.25.25.25h4a.75.75 0 01.75.75v4c0 .138.112.25.25.25h4.5a.25.25 0 00.25-.25v-4a.75.75 0 01.75-.75h4a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-4a.75.75 0 01-.75-.75v-4a.25.25 0 00-.25-.25h-4.5zM8 4.75C8 3.784 8.784 3 9.75 3h4.5c.966 0 1.75.784 1.75 1.75V8h3.25c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0119.25 16H16v3.25A1.75 1.75 0 0114.25 21h-4.5A1.75 1.75 0 018 19.25V16H4.75A1.75 1.75 0 013 14.25v-4.5C3 8.784 3.784 8 4.75 8H8V4.75z",
    fill: "#333230"
  })));
}
export default SvgPldServices;